/**
 * エラーレポート
 * @param error - エラーオブジェクト
 * @param context - エラーのコンテキスト情報
 */
export function reportError(error: Error | unknown, context: Record<string, unknown> = {}): void {
    const err = error instanceof Error ? error : new Error(String(error));
    console.error('Error:', err, context);
    
    // 本番環境でのエラー送信（必要に応じて有効化）
    /*
    if (window.location.hostname !== 'localhost') {
        fetch('/api/error', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                error: err.message,
                stack: err.stack,
                context: context,
                userAgent: navigator.userAgent,
                url: window.location.href,
                timestamp: new Date().toISOString()
            })
        }).catch(() => {});
    }
    */
}

/**
 * グローバルエラーハンドラーを設定
 */
export function setupErrorHandlers(): void {
    window.addEventListener('error', (event) => {
        reportError(event.error, {
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno
        });
    });
    
    window.addEventListener('unhandledrejection', (event) => {
        reportError(new Error(String(event.reason)), {
            type: 'unhandledrejection'
        });
    });
}

